'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnquiryService = function () {
  function EnquiryService($http, appConfig) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EnquiryService);
    this.$http = $http;
    this.appConfig = appConfig;
  }

  (0, _createClass3.default)(EnquiryService, [{
    key: 'getEnquiry',
    value: function getEnquiry(entityId, contactId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/get/' + entityId + '/' + contactId));
    }
  }, {
    key: 'updateOwner',
    value: function updateOwner(enquiryId, ownerId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/updateOwner/' + enquiryId + '/' + ownerId));
    }
  }, {
    key: 'editEnquiry',
    value: function editEnquiry(enquiry) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/edit', enquiry);
    }
  }, {
    key: 'canConfirmEnquiry',
    value: function canConfirmEnquiry(enquiry) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/canconfirm', enquiry);
    }
  }, {
    key: 'listEnquiries',
    value: function listEnquiries(filterParams) {
      var query = '';

      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
      query += '&ascending=' + filterParams.pageCriteria.ascending;
      query += '&entityId=' + filterParams.entityId;

      if (filterParams.subject) {
        query += '&subject=' + filterParams.subject;
      }

      if (filterParams.contactName) {
        query += '&contactName=' + filterParams.contactName;
      }

      if (filterParams.ownerName) {
        query += '&ownerName=' + filterParams.ownerName;
      }

      if (filterParams.status) {
        query += '&enquiryState=' + filterParams.status;
      }

      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/enquiry/list' + query);
    }
  }, {
    key: 'updateContactState',
    value: function updateContactState(entityId, contactId, state) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/update/' + entityId + '/' + contactId + '/' + state));
    }
  }, {
    key: 'duplicate',
    value: function duplicate(enquiryId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/duplicate/' + enquiryId));
    }
  }, {
    key: 'notifyFinance',
    value: function notifyFinance(enquiryId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/notifyFinance/' + enquiryId));
    }
  }, {
    key: 'addShowroomEntry',
    value: function addShowroomEntry(entry) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/addshowroomentry', entry);
    }
  }, {
    key: 'removeTradeIn',
    value: function removeTradeIn(enquiryId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/removetradein/' + enquiryId));
    }
  }, {
    key: 'addExistingTradeIn',
    value: function addExistingTradeIn(currentEnquiryId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/addexistingtradein/' + currentEnquiryId));
    }
  }, {
    key: 'closeLinkedEnquiries',
    value: function closeLinkedEnquiries(enquiryIds) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/closeLinkedEnquiries/?enquiryIds=' + enquiryIds));
    }
  }, {
    key: 'sendWebLeadFollowUpEmail',
    value: function sendWebLeadFollowUpEmail(data) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/sendwebleadfollowupemail/', data);
    }
  }, {
    key: 'addPayment',
    value: function addPayment(enquiryId, payment) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/enquiry/addpayment/' + enquiryId), payment);
    }
  }, {
    key: 'editPayment',
    value: function editPayment(payment) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/enquiry/editpayment/', payment);
    }
  }, {
    key: 'deletePayment',
    value: function deletePayment(enquiryPaymentId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/enquiry/deletepayment/' + enquiryPaymentId));
    }
  }]);
  return EnquiryService;
}();

exports.default = EnquiryService;


// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiry.service.js